import {MediaObjectInterface} from '../../core/interfaces/media-object.interface';
import {MediaTypeEnum} from '../../core/enums/media-type.enum';

/** A poster does not make a video playable. Validate the selected item itself. */
export function hasPlayableMediaSource(media: MediaObjectInterface | null | undefined): boolean {
  const names = media?.type === MediaTypeEnum.VIDEO
    ? ['m3u8', 'original']
    : ['thumb_md', 'thumb_sm', 'thumb_md_webp', 'thumb_sm_webp', 'webp', 'original'];
  return Array.isArray(media?.hyperlinks)
    && media.hyperlinks.some((link) => names.includes(link?.name) && !!link?.uri);
}
